import { useEffect, useState } from 'react'

import { useAppStore } from '@src/app/context'

import type { AudioDeviceType } from './AudioDeviceProps'

export default function useActiveAudioDevice(deviceType: AudioDeviceType) {
  const app = useAppStore()
  const [activeAudioDevice, setActiveAudioDevice] = useState<MediaDeviceInfo | undefined>(
    undefined,
  )
  useEffect(() => {
    if (deviceType === 'microphone' && app.service.voice.defaultAudioInputDeviceId) {
      return setActiveAudioDevice(
        app.service.voice.inputDevices.get(app.service.voice.defaultAudioInputDeviceId),
      )
    } else if (
      deviceType === 'ringtone' &&
      app.service.voice.defaultAudioRingtoneDeviceId
    ) {
      return setActiveAudioDevice(
        app.service.voice.audioDevices.get(
          app.service.voice.defaultAudioRingtoneDeviceId,
        ),
      )
    } else if (deviceType === 'speaker' && app.service.voice.defaultAudioOutputDeviceId) {
      return setActiveAudioDevice(
        app.service.voice.audioDevices.get(app.service.voice.defaultAudioOutputDeviceId),
      )
    }
    return setActiveAudioDevice(undefined)
  }, [
    app.service.voice.defaultAudioInputDeviceId,
    app.service.voice.defaultAudioOutputDeviceId,
    app.service.voice.defaultAudioRingtoneDeviceId,
    app.service.voice.inputDevices,
    app.service.voice.audioDevices,
    deviceType,
  ])
  return activeAudioDevice
}
